{
	"name": "drafter-js-client",
	"version": "2.0.0",
	"private": false,
	"type": "module",
	"files": [
		"dist",
		"README.md",
		"LICENSE.txt"
	],
	"scripts": {
		"update": "node scripts/update-skulpt.mjs",
		"build": "tsup --minify --sourcemap",
		"watch": "tsup --watch",
		"update-skulpt": "node scripts/update-skulpt.mjs",
		"precompile": "node scripts/precompile-python.mjs --minify",
		"precompile:watch": "chokidar \"../src/drafter/**/*.py\" \"./src/bridge/**/*.ts\" -d 200 --initial -c \"node scripts/precompile-python.mjs\"",
		"dev": "node scripts/update-skulpt.mjs && tsup --watch",
		"test": "node --experimental-vm-modules node_modules/jest/bin/jest.js --selectProjects unit",
		"test:coverage": "node --experimental-vm-modules node_modules/jest/bin/jest.js --selectProjects unit --coverage",
		"test:integration": "node scripts/run-integration-tests.mjs",
		"test:e2e": "node playground/build-playground.mjs && node e2e/prefetch-pyodide-packages.mjs && playwright test",
		"test:skulpt": "node --experimental-vm-modules node_modules/jest/bin/jest.js --selectProjects skulpt",
		"test:all": "npm test && npm run test:integration && npm run test:skulpt",
		"test:watch": "node --experimental-vm-modules node_modules/jest/bin/jest.js --watch",
		"playground:build": "npm run build && node playground/build-playground.mjs",
		"playground": "npm run playground:build && python -m http.server 8777 --directory playground"
	},
	"devDependencies": {
		"@chialab/esbuild-plugin-postcss": "^0.18.0",
		"@jest/globals": "^30.2.0",
		"@testing-library/jest-dom": "^6.9.1",
		"@testing-library/user-event": "^14.6.1",
		"@types/css-tree": "^2.3.11",
		"@types/jest": "^30.0.0",
		"@types/jquery": "^3.5.33",
		"@types/leaflet": "^1.9.21",
		"@types/node": "^24.13.3",
		"@types/wicg-file-system-access": "^2023.10.7",
		"autoprefixer": "^10.4.21",
		"browserslist-to-esbuild": "^2.1.1",
		"chokidar": "^4.0.3",
		"chokidar-cli": "^3.0.0",
		"commander": "^14.0.2",
		"cssnano": "^7.1.2",
		"dotenv": "^17.2.3",
		"jest": "^30.2.0",
		"jest-environment-jsdom": "^30.2.0",
		"playwright": "^1.56.1",
		"postcss": "^8.5.6",
		"postcss-preset-env": "^10.4.0",
		"py-ast": "^1.9.0",
		"terser": "^5.44.0",
		"ts-jest": "^29.4.5",
		"ts-node": "^10.9.2",
		"tsup": "^8",
		"typescript": "^5"
	},
	"dependencies": {
		"@codemirror/lang-html": "^6.4.11",
		"@codemirror/lang-python": "^6.2.1",
		"codemirror": "^6.0.2",
		"css-tree": "^3.2.1",
		"diff": "^9.0.0",
		"diff2html": "^3.4.52",
		"highlight.js": "^11.11.1",
		"i18next": "^25.6.2",
		"jsx-dom": "^8.1.6",
		"leaflet": "^1.9.4",
		"lit": "^3.3.1",
		"parse5": "^8.0.1",
		"pyodide": "^314.0.5",
		"string-diff-viewer": "^0.4.4"
	},
	"browserslist": [
		"defaults",
		"not IE 11",
		"maintained node versions"
	]
}
